import { AgCharts, AgChartProps } from "ag-charts-react";
import React from "react";
import { useAppSelector } from "../../../../../hooks";
import { selectNrOfFiltredIssues, selectStatusDistributionForChart } from "../../issueSelectors";

export interface IAgChartDataItem {
  name: string;
  y: number;
  color?: string;
}

export const StatusCircleChart: React.FC = () => {
  const nrOfFilteredIssues = useAppSelector(selectNrOfFiltredIssues);
  const circleChartDataItems = useAppSelector(selectStatusDistributionForChart);

  // Om inga issues → visa tom cirkel eller meddelande
  if (nrOfFilteredIssues === 0) {
    return <div style={{ padding: 20, textAlign: "center", color: "#666" }}>Ingen data att visa</div>;
  }

  const options: AgChartProps["options"] = {
    height: 400,
    data: circleChartDataItems,
    animation: { enabled: true },
    title: {
      text: "Status",
      fontWeight: "bold",
      fontSize: 18,
    },
    series: [
      {
        type: "pie",
        angleKey: "y",
        legendItemKey: "name",
        sectorLabelKey: "y",
        calloutLabelKey: "name",
        cornerRadius: 2,
        fills: circleChartDataItems.map((item) => item.color || "#cccccc"),
        tooltip: {
          renderer: (params) => {
            const datum = params.datum as IAgChartDataItem;
            const percentage = nrOfFilteredIssues > 0 ? ((datum.y / nrOfFilteredIssues) * 100).toFixed(1) : "0.0";
            return {
              title: datum.name,
              content: `${datum.y} stk • ${percentage}%`,
            };
          },
        },
      },
    ],
    legend: {
      item: {
        label: { fontSize: 14 },
      },
    },
  };

  return <AgCharts options={options} />;
};
